import React, { useContext } from 'react'
import { Grid, GridColumn, Tab } from 'semantic-ui-react'
import { observer } from 'mobx-react-lite'
import { RootStoreContext } from '../../../App/stores/RootStore'
import RequestNoteList from "./RequestNotes/RequestNoteList";
import RequestReviewNoteList from "./RequestReviewNotes/RequestReviewNoteList";
import RequestReviewDocumentNoteList from "./RequestReviewDocumentNotes/RequestReviewDocumentNoteList";
import RequestNoteFilters from "./RequestNotes/RequestNoteFilters";
import RequestReviewNoteFilters from "./RequestReviewNotes/RequestReviewNoteFilters";
import RequestReviewDocumentNoteFilters from "./RequestReviewDocumentNotes/RequestReviewDocumentNoteFilters";
import LoadingComponent from "../../../App/layout/LoadingComponent";

const NoteList: React.FC = () => {
    const rootStore = useContext(RootStoreContext)
    const { loadingInitial } = rootStore.requestNoteStore;
    const { loadingInitialReviewNotes } = rootStore.requestReviewNoteStore;
    const { loadingInitialReviewDocumentNotes } = rootStore.requestReviewDocumentNoteStore;
    const panes = [
        {
            menuItem: 'Request Notes',
            render: () =>
                <Tab.Pane attached={false}>
                    <Grid>
                        <GridColumn width={12}>
                            <LoadingComponent active={loadingInitial} content='Loading Request Notes...' />
                            <RequestNoteList />
                        </GridColumn>
                        <Grid.Column width={4}>
                            <RequestNoteFilters />
                        </Grid.Column>
                    </Grid>
                </Tab.Pane>,
        },
        {
            menuItem: 'Request Review Notes',
            render: () =>
                <Tab.Pane attached={false}>
                    <Grid>
                        <GridColumn width={12}>
                            <LoadingComponent active={loadingInitialReviewNotes} content='Loading Request Review Notes...' />
                            <RequestReviewNoteList />
                        </GridColumn>
                        <Grid.Column width={4}>
                            <RequestReviewNoteFilters />
                        </Grid.Column>
                    </Grid>
                </Tab.Pane>,
        },
        {
            menuItem: 'Request Review Document Notes',
            render: () =>
                <Tab.Pane attached={false}>
                    <Grid>
                        <GridColumn width={12}>
                            <LoadingComponent active={loadingInitialReviewDocumentNotes} content='Loading Request Review Document Notes...' />
                            <RequestReviewDocumentNoteList />
                        </GridColumn>
                        <Grid.Column width={4}>
                            <RequestReviewDocumentNoteFilters />
                        </Grid.Column>
                    </Grid>
                </Tab.Pane>,
        },
    ]

    return (
        <Tab menu={{ pointing: true }} panes={panes} />
    )
}
export default observer(NoteList);